/**
 * @fileoverview Affiliate adjustment copy (MOR-438)
 *
 * Split out from the table component so the module exports only functions —
 * mixing component and non-component exports breaks React Fast Refresh.
 */

/**
 * Plain-language description of how a fee is adjusted, so the table's
 * "Adjustment" column is interpretable without opening the contract.
 */
export function adjustmentExplainer(
  adj:
    | { kind: "none" }
    | { kind: "cost_of_service" }
    | { kind: "fixed_percent"; percent: number }
    | {
        kind: "margin_protection";
        fullMarginPercent: number;
        floorMarginPercent: number;
      },
): string {
  switch (adj.kind) {
    case "none":
      return "Fee is the rate applied to gross, with no adjustment.";
    case "cost_of_service":
      return "Vendor costs are deducted from gross before the rate applies.";
    case "fixed_percent":
      return `${adj.percent}% of gross is deducted before the rate applies.`;
    case "margin_protection":
      return `Full fee at ${adj.fullMarginPercent}%+ margin; between ${adj.floorMarginPercent}% and ${adj.fullMarginPercent}% the fee is scaled by margin ÷ ${adj.fullMarginPercent}%; below ${adj.floorMarginPercent}% no fee is payable.`;
  }
}
